import React, { useState, useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import Header from 'containers/SignupPages/Header';
import messages from 'containers/SignupPages/PersonalInfo/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/SignupPages/PersonalInfo/Form';
import { useDispatch, useSelector } from 'react-redux';
import { getProduitEpargn } from 'store/contract/actions';
import {
  getIsloadingProductSelector,
  getProductSelector,
} from 'store/contract/selectors';

const PersonalInfo = (props: {
  intl: IntlShape;
  isLoading: boolean;
  onSubmitStep: Function;
}) => {
  const [loadingProducts, setLoadingProducts] = useState<boolean>(false);
  const dispatch = useDispatch();
  const isLoadingProducts = useSelector(getIsloadingProductSelector);
  const products = useSelector(getProductSelector);

  useEffect(() => {
    if (loadingProducts) {
      dispatch(getProduitEpargn());
    }
  }, [dispatch, loadingProducts]);

  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={translate({ ...messages.subTitle }, props)}
      />
      <Form
        onSubmit={props.onSubmitStep}
        isLoading={props.isLoading}
        isLoadingProducts={isLoadingProducts}
        products={products}
        setLoadingProducts={setLoadingProducts}
      />
    </React.Fragment>
  );
};

export default injectIntl(PersonalInfo);
